import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StoreI18n } from '../../../Types/StoreTypes';

const initialState: StoreI18n = {
    i18n: null,
    selectedLanguage: '',
};

const i18nSlice = createSlice({
    name: 'i18n',
    initialState,
    reducers: {
        setI18n: (state, action: PayloadAction<StoreI18n['i18n']>) => {
            state.i18n = action.payload;
        },
        setSelectedLanguage: (state, action: PayloadAction<StoreI18n['selectedLanguage']>) => {
            state.selectedLanguage = action.payload;
        },
    },
});

export const { setI18n, setSelectedLanguage } = i18nSlice.actions;

export default i18nSlice.reducer;
